import { UserWorkScheduleAppointmentDto } from "@/models/club";
import { useGetImage } from "@/utilities/helper/getImage";
import { Avatar, Divider, Group, Menu, Stack, Text } from "@mantine/core";
import { IconClock, IconPencil } from "@tabler/icons-react";
import { Moment } from "moment-jalaali";

type Props = {
  selectedTeam: UserWorkScheduleAppointmentDto;
  selectedDate: Moment;
  openRepeatableShifts: () => void;
  openOneDayShift: () => void;
  closeMenu: () => void;
};

function AddShiftMenu({
  selectedTeam,
  selectedDate,
  openRepeatableShifts,
  openOneDayShift,
  closeMenu,
}: Props) {
  const { imageUrl } = useGetImage({ image: selectedTeam?.user?.image });
  return (
    <Stack h="240px">
      <Stack justify="center" align="center" gap="5" flex={1}>
        <Avatar
          variant="outline"
          color="blue"
          radius="xl"
          size="lg"
          p="2"
          styles={{
            image: {
              borderRadius: "100px",
            },
            root: {
              border: `3px solid ${selectedTeam?.user?.calendarColor}`,
            },
          }}
          src={imageUrl}
        >
          {selectedTeam?.user?.firstName?.charAt(0) || ""}
        </Avatar>
        <Text size="md" fw="500">
          {selectedTeam?.user?.firstName} {selectedTeam?.user?.lastName}
        </Text>
        <Text size="xs" c="gray.7">
          {selectedDate.format("dddd, jDD jMMMM")}
        </Text>
      </Stack>

      <Stack gap="xs">
        <Menu>
          <Menu.Item
            onClick={() => {
              openOneDayShift();
              closeMenu();
            }}
          >
            <Group justify="space-between">
              <Text fw="500"> ویرایش این روز </Text>
              <IconPencil size={20} stroke={1} />
            </Group>
          </Menu.Item>
          <Divider />
          <Menu.Item
            onClick={() => {
              openRepeatableShifts();
              closeMenu();
            }}
          >
            <Group justify="space-between">
              <Text fw="500"> تنظیم شیفت‌های تکراری </Text>
              <IconClock size={20} stroke={1} />
            </Group>
          </Menu.Item>
        </Menu>
      </Stack>
    </Stack>
  );
}

export default AddShiftMenu;
